import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const StageContext = createContext<{
  params?: Routing.StageParams
}>({})

export { StageContext }
